import { DeckListWidget } from '@/widgets/deck-list';

export function Decks() {
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="font-display text-4xl tracking-wide text-ugin-text">Decks</h1>
        <p className="text-sm text-ugin-text-muted">
          Sleeve a list, paste it in, watch Ugin draw the curves.
        </p>
      </header>
      <DeckListWidget />
    </div>
  );
}
